import { useQuery } from '@tanstack/react-query';
import { wbsApiClient } from 'src/api/FiretrolApiClientInstances';
import { queryKeys } from 'src/api/queries/queryKeys';
import { toCancelToken } from 'src/api/queries/queryClient';

/** @registry WBS tree for a job; every WBS, progress and daily-progress write refreshes it. */
export function useJobWbs(jobId: number | null | undefined) {
  return useQuery({
    queryKey: queryKeys.wbs.forJob(jobId ?? -1),
    queryFn: ({ signal }) =>
      wbsApiClient.getJobWbs(jobId!, toCancelToken(signal)),
    enabled: jobId != null && jobId > 0,
    staleTime: 0,
    meta: { errorContext: 'job WBS' },
  });
}
